import styled from '@emotion/styled';
import { Grid } from '@kc-console/common-ui';

import { FORM_LAYOUT_STYLE } from '../../../constants/layout';

import type { FormContentContainerProps } from './CreateFormContainer';

const FormContentContainer = ({
  children,
  summary,
  stepper,
  topology,
  chart,
}: FormContentContainerProps) => {
  if (summary) {
    return (
      <MainContainer gap={4} flexWrap={'nowrap'}>
        <ContentContainer>{children}</ContentContainer>
        <SummaryContainer>{summary}</SummaryContainer>
      </MainContainer>
    );
  }

  if (stepper) {
    return (
      <MainContainer gap={4} flexWrap={'nowrap'}>
        <ContentContainer>{children}</ContentContainer>
        <StepperContainer>{stepper}</StepperContainer>
      </MainContainer>
    );
  }

  if (topology) {
    return (
      <MainContainer gap={4} flexWrap={'nowrap'}>
        <ContentContainer>{children}</ContentContainer>
        <TopologyContentContainer>{topology}</TopologyContentContainer>
      </MainContainer>
    );
  }

  if (chart) {
    return (
      <MainContainer gap={4} flexWrap={'nowrap'}>
        <ContentContainer>{children}</ContentContainer>
        <ChartContentContainer>{chart}</ChartContentContainer>
      </MainContainer>
    );
  }
  return (
    <MainContainer gap={4} flexWrap={'nowrap'}>
      <ContentContainer>{children}</ContentContainer>
    </MainContainer>
  );
};

export default FormContentContainer;

// minheight: 100% - footer 높이
const MainContainer = styled(Grid)`
  display: flex;
  min-height: calc(100% - 80px);
  min-width: ${FORM_LAYOUT_STYLE.CONTAINER_WIDTH}px;
  padding: 16px 32px 32px 32px;
`;

const SummaryContainer = styled(Grid)`
  position: sticky;
  top: 16px;
  padding: 16px 0px 0px 40px;
  width: 400px;
  height: 100%;
  min-width: 400px;
  word-break: break-word;
`;

const StepperContainer = styled(Grid)``;

const TopologyContentContainer = styled(Grid)`
  position: sticky;
  top: 16px;
  min-width: 400px;
  height: 600px;
  flex: 1;
`;

const ChartContentContainer = styled(Grid)`
  position: sticky;
  top: 16px;
  min-width: 800px;
  height: 100%;
  flex: 1;
`;

const ContentContainer = styled(Grid)`
  min-width: ${FORM_LAYOUT_STYLE.CONTENT_MIN_WIDTH}px;
  flex: 1;
  width: 100%;
  max-width: 960px;
`;
